import { motion } from "framer-motion";
import { Phone, MessageCircle, MapPin, Clock3 } from "lucide-react";

const WA_URL =
  "https://wa.me/905392196017?text=Merhaba%20Konya%20%C3%87ekicim,%20yolda%20kald%C4%B1m.%20Konum%20payla%C5%9Fmak%20istiyorum.";

export default function Footer() {
  return (
    <footer id="iletisim" data-testid="contact-footer" className="relative scroll-mt-20">
      <div className="hazard-stripes h-2 w-full" aria-hidden="true" />
      <div className="bg-night-950 border-t border-white/5 pt-16 lg:pt-24 pb-28 lg:pb-12 relative overflow-hidden">
        <div className="absolute -bottom-32 left-1/2 -translate-x-1/2 w-[700px] h-[400px] rounded-full bg-brand/10 blur-[160px] pointer-events-none" aria-hidden="true" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-brand">7/24 Acil Çağrı Hattı</p>
            <h2 className="font-display font-extrabold uppercase text-white mt-4 leading-[0.9] text-[clamp(2.6rem,7vw,5.5rem)]">
              Yolda kalmayın,
              <br />
              <span className="text-brand">bir tuşla ulaşın</span>
            </h2>
            <a
              href="tel:+905392196017"
              data-testid="footer-giant-phone-link"
              className="block font-display font-extrabold tracking-tight text-white hover:text-brand transition-colors duration-300 mt-6 text-[clamp(2.2rem,8vw,6.5rem)] leading-none"
            >
              0539 219 60 17
            </a>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="tel:+905392196017"
                data-testid="footer-call-button"
                className="inline-flex items-center gap-2.5 bg-brand hover:bg-brand-light text-night-900 rounded-full px-8 py-4 font-display font-bold text-xl uppercase tracking-wide transition-all duration-200 active:scale-95 shadow-[0_0_30px_rgba(255,107,0,0.35)]"
              >
                <Phone className="w-5 h-5" strokeWidth={2.5} /> Hemen Ara
              </a>
              <a
                href={WA_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-button"
                className="inline-flex items-center gap-2.5 rounded-full px-8 py-4 border border-wa/50 text-wa hover:bg-wa hover:text-night-900 font-display font-semibold text-xl uppercase tracking-wide transition-all duration-200 active:scale-95"
              >
                <MessageCircle className="w-5 h-5" strokeWidth={2.5} /> WhatsApp
              </a>
            </div>
          </motion.div>

          <div className="mt-16 lg:mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-6 text-sm text-slate-500">
            <div className="flex items-center gap-2" data-testid="footer-brand">
              <img
                src="/logo-badge-dark.png"
                alt=""
                width="36"
                height="36"
                className="w-9 h-9 rounded-lg"
              />
              <span>
                <strong className="text-slate-300">Konya Çekicim</strong> · Adem ILDIRAR
              </span>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
              <span className="flex items-center gap-2">
                <MapPin className="w-4 h-4 text-brand" /> Konya, Türkiye
              </span>
              <span className="flex items-center gap-2">
                <Clock3 className="w-4 h-4 text-brand" /> 7/24 Açık
              </span>
              <span className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-brand" /> İl içi & İl dışı
              </span>
            </div>
            <p>© {new Date().getFullYear()} Konya Çekicim</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
